
document.addEventListener("DOMContentLoaded", function () {
    const input = document.getElementById("country-search");
    const countryMap = window.COUNTRY_MAP || {};

    if (!input) {
        return;
    }

    const wrapper = document.createElement("div");
    wrapper.className = "country-search-suggest-wrap";

    const suggestionBox = document.createElement("div");
    suggestionBox.className = "country-search-suggest";
    suggestionBox.style.display = "none";

    input.parentNode.insertBefore(wrapper, input);
    wrapper.appendChild(input);
    wrapper.appendChild(suggestionBox);

    function escapeHtml(str) {
        return String(str)
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#39;");
    }

    function normalizeText(str) {
        return String(str || "").trim();
    }

    function getMatches(keyword) {
        const q = normalizeText(keyword);
        if (!q) {
            return [];
        }

        return Object.entries(countryMap).filter(function ([name]) {
            return name.indexOf(q) === 0;
        });
    }

    function renderSuggestions(matches) {
        if (!matches.length) {
            suggestionBox.innerHTML = "";
            suggestionBox.style.display = "none";
            return;
        }

        const html = matches.map(function ([name, item]) {
            return (
                '<a class="country-search-suggest-item" href="' + escapeHtml(item.url) + '">' +
                    escapeHtml(name) +
                '</a>'
            );
        }).join("");

        suggestionBox.innerHTML = html;
        suggestionBox.style.display = "block";
    }

    input.addEventListener("input", function () {
        renderSuggestions(getMatches(input.value));
    });

    input.addEventListener("focus", function () {
        renderSuggestions(getMatches(input.value));
    });

    document.addEventListener("click", function (event) {
        if (!wrapper.contains(event.target)) {
            suggestionBox.style.display = "none";
        }
    });
});


